import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Services
import { APIURL } from '../../services'; 
@Component({
	selector: 'bk-video',
	templateUrl: './video.component.html',
	encapsulation: ViewEncapsulation.None
})
export class VideoComponent implements OnInit {
	readonly imgBase: string = this.APIURL.imgBase;
	url: string | null = '';
	videoType: string = 'custom';
	videoId: string = '';
	constructor(private route: ActivatedRoute, private APIURL: APIURL) {	
	}
	ngOnInit(): void {
		this.route.queryParamMap.subscribe(queryParams => {
			if(queryParams.get("url")){
				this.url = queryParams.get("url");
				this.fetchVideoType();
			}
		})
	}
	private fetchVideoType(): void {
		if(this.url){
			if(this.url.includes('youtube')){
				this.videoType = 'youtube';
				this.videoId = this.getYoutubeVideoId(this.url);
			}else if(this.url.includes('vimeo')){
				this.videoType = 'vimeo';
				this.videoId = this.getVimeoVideoId(this.url);
			}else{
				this.videoType = 'custom';
			}
		}
	}
	/**
	 * Extracts the Youtube video ID from a Youtube video URL.
	 * @param {string} url - The Youtube video URL.
	 * @returns {string} - The Youtube video ID.
	 */
	public getYoutubeVideoId(url: string): string {
		// Regular expression to match a Youtube video URL and extract the video ID.
		let VID_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
		let videoId: any = url.match(VID_REGEX);
		// If a video ID is found, return it. Otherwise, return an empty string.
		return (videoId && videoId[1]) ? videoId[1] : '';
	}
	/**
	 * Extracts the Vimeo video ID from a Vimeo video URL.
	 * @param {string} url - The Vimeo video URL.
	 * @returns {string} - The Vimeo video ID.
	 */
	public getVimeoVideoId(url: string): string {
		// Regular expression to match a Vimeo video URL and extract the video ID.
		let VID_REGEX = /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
		let videoId: any = url.match(VID_REGEX);
		// If a video ID is found, return it. Otherwise, return an empty string.
		return (videoId && videoId[1]) ? videoId[1] : '';
	}
}